import { Injectable } from '@angular/core';
import { BehaviorSubject, map } from 'rxjs';
import { Tipo } from 'src/class/tipo';
import { DataService } from '../data.service';
import { ToastService } from '../toast.service';
import { Router } from '@angular/router';
import { plainToClass } from 'class-transformer';
import { LocalhostService } from '../localhost.service';
import { ContaService } from './conta.service';
import { AuthService } from '../auth.service';
import { NotificacaoSistemaService } from './notificacao-sistema.service';

@Injectable({
  providedIn: 'root'
})
export class TipoService {

  private tipos: Tipo[] = [];
  private tiposSubject = new BehaviorSubject<Tipo[]>(this.tipos);

  constructor(
    private router: Router,
    private localhostService: LocalhostService,
    private notificacaoService: NotificacaoSistemaService,
    private toast: ToastService,
    private conta: ContaService,
    private userService: AuthService
  ) {
    this.tipos = [];
    // this.getTipo();
  }



  async criarTipo(tipo: Tipo, empresaSigla: any) {
    // console.log("criarTipo", tipo);
    tipo.descricao.status = null;
    tipo.nome.status = null;

    try {
      const conta = await this.conta.p_getSiglaConta('contas', empresaSigla);

      // console.log('Dados da conta: criarTipo', conta);

      const response = await this.localhostService.postDadosId(`${conta.id}_tipos`, tipo);
      // console.log('Tipo criado com sucesso:', response);

      // Atualize a lista local de agendas
      this.tipos.push(tipo);
      this.tiposSubject.next(this.tipos);

      // Notifique o usuário sobre o sucesso
      this.showSuccess('Tipo criado com sucesso');

      // Nova notificação
      // 1 - empresaSigla: any,
      // 2 - titulo: string,
      // 3 - texto: string,
      // 4 - rotaSemParamNome: string,
      // 5 - rotaSemParamListar: string,
      // 6 - rotaComParamNome: string = "",
      // 7 - rotaComParamCaminho: string = "",
      // 8 - rotaComParamParam: string = "",
      // 9 - linkExternoNome: string = "",
      // 10 - linkExternoURL: string = "",
      // 11 - idReferencia: string,
      // 12 - tipo: string,
      // 13 - idResponsavel: string,
      // 14 - nomeResponsavel: string

      const usr = await this.userService.carregarUsuario(empresaSigla)

      this.notificacaoService.criarNotificacao(
        empresaSigla,
        `${tipo.nome.valor}`,
        `Tipo criado.`,
        'Listar Tipos',
        'tipos',
        'Editar Tipo',
        `tipos/tipo`,
        tipo.id?.toString(),
        '',
        '',
        tipo.id!.toString(),
        `Tipo`,
        `${usr.id}`,
        `${usr.displayName.valor}`
      )

      return true;
    } catch (error) {
      // console.error('Erro ao criar tipo:', error);
      // Trate o erro conforme necessário
      return false;
    }
  }

  getAllTipo() {
    return this.tiposSubject.asObservable().pipe(
      map(tipos => tipos)
    );
  }

  async getTipo(empresaSigla: any) {

    await this.conta.p_getSiglaConta('contas', empresaSigla)
    .then((conta) => {
      // Faça algo com os dados obtidos
      // console.log('Dados da conta: getTipo', conta);

      this.localhostService.getDados(`${conta.id}_tipos`).subscribe(
        (tipoFromServer: any[]) => {
          if (tipoFromServer) {
            // Mapeia os dados para a estrutura desejada
            const tipoArray: Tipo[] = tipoFromServer.map(tipo => plainToClass(Tipo, tipo));

            // console.log(tipoArray);

            this.tipos = tipoArray;
            this.tiposSubject.next(this.tipos);
            // this.updateLocalStorage();
          } else {
            this.tipos = [];
          }
        },
        (error) => {
          // console.error('Erro ao obter tipos:', error);
        }
      );
    },
    (error: any) => {
      // console.error('Erro ao obter tipos:', error);
      // Trate o erro conforme necessário
    }).catch((error) => {
      // Trate o erro
      // console.log('Erro ao obter dados da conta:', error);
    });


  }

  private updateLocalStorage() {
    localStorage.setItem("Tipo", JSON.stringify(this.tipos));
    DataService.set("Tipo", this.tipos);
  }

  private showSuccess(msg: string){
    this.toast.showToast('<i class="bi bi-check-circle-fill " style="font-size: 25px;padding-right: 10px;"></i> ' + msg, 'success');
  }

  private showError(msg: string){
    this.toast.showToast('<i class="bi bi-x-circle-fill" style="font-size: 25px;padding-right: 10px;"></i> ' + msg, 'danger');
  }

  private showInfo(msg: string) {
    this.toast.showToast('<i class="bi bi-info-circle-fill" style="font-size: 25px;padding-right: 10px;"></i> ' + msg, 'info');
  }
}
